import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProjectObjectiveOperational } from "../Model/ProposalProjectObjectiveOperational";

export async function deleteProposalObjectiveOperational(idProposalProject, idObj) {
    let response = await getAPIResponse("/v1/proposal-project-objective-operational/"+idProposalProject+'/'+idObj, {} , "DELETE");
    if (response === null) {
        return null;
    }
    let proposalProjectObjectiveOperational = ProposalProjectObjectiveOperational.createFromResponseData(response);
    return proposalProjectObjectiveOperational;
}